const COMMAND_CENTER_SIGNAL_PERMISSIONS = new Set([
  'assets.registry.read',
  'estimating.estimates.read',
  'finance.invoices.read',
  'projects.projects.read',
  'tasks.tasks.read-all',
  'tasks.tasks.read-own',
]);

export function canAccessCommandCenter(permissions: readonly string[]): boolean {
  return permissions.some((permission) => COMMAND_CENTER_SIGNAL_PERMISSIONS.has(permission));
}
